// --------------------------------------------------------------------------
// Auto Trim all leading/trailing spaces from from inputs
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context };

    function init() {
        $.each($.validator.methods, function (key, value) {
            $.validator.methods[key] = function () {
                if (arguments.length > 0) {
                    var el = $(arguments[1]);
                    el.val($.trim(el.val()));
                }

                return value.apply(this, arguments);
            };
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/trim-whitespace.js
// module id = 511
// module chunks = 0